import { AddToCartItem, ProductBuilderMachineContext } from '../types';

type HoneycombAddonProducts = (
  context: ProductBuilderMachineContext,
  upi: string,
  roomName: string,
  parentProductTitle: string,
) => AddToCartItem[];

export const getHoneycombAddonProducts: HoneycombAddonProducts = (
  {
    measureInsurance: measureInsuranceAddonProducts,
    powerSupply: powerSupplyAddonProducts,
    remoteControl: remoteControlAddonProducts,
    extensionPole: extensionPoleAddonProducts,
    wifiHub: wifiHubAddonProducts,
    smartRelease: smartReleaseAddonProducts,
    fascia: fasciaAddonProducts,
    lightGuards: lightGuardsAddonProducts,
    honeycombVerticalCentreOpeningSurcharge: honeycombVerticalCentreOpeningSurchargeAddonProducts,
    quantity,
    custom: {
      measureInsurance,
      powerSupply,
      remoteControl,
      extensionPole,
      wifiHub,
      smartRelease,
      fascia,
      lightGuards,
      honeycombVerticalCentreOpeningSurcharge,
    },
  },
  upi,
  roomName,
  parentProductTitle,
) => {
  return measureInsuranceAddonProducts
    .concat(powerSupplyAddonProducts)
    .concat(remoteControlAddonProducts)
    .concat(extensionPoleAddonProducts)
    .concat(smartReleaseAddonProducts)
    .concat(wifiHubAddonProducts)
    .concat(fasciaAddonProducts)
    .concat(lightGuardsAddonProducts)
    .concat(honeycombVerticalCentreOpeningSurchargeAddonProducts)
    .filter(({ first_available_variant: { id }, variants }) => {
      const isMeasureInsurance = id === measureInsurance;
      const isPowerSupply = Array.isArray(powerSupply) && id === powerSupply[0];
      const isRemoteControl = id === remoteControl;
      const isExtensionPole = id === extensionPole;
      const isSmartRelease = id === smartRelease;
      const isWifiHub = id === wifiHub;
      const isFascia = variants.find(variant => variant.id === fascia);
      const isLightGuards = variants.find(
        variant => variant.id === lightGuards,
      );

      const isHoneycombVerticalCentreOpeningSurcharge =
        id === honeycombVerticalCentreOpeningSurcharge;

      return (
        isMeasureInsurance ||
        isPowerSupply ||
        isRemoteControl ||
        isExtensionPole ||
        isWifiHub ||
        isSmartRelease ||
        isFascia ||
        isLightGuards ||
        isHoneycombVerticalCentreOpeningSurcharge
      );
    })

    .map(({ first_available_variant: { id }, variants }) => {
      const isMeasureInsurance = id === measureInsurance;
      const isWifiHub = id === wifiHub;
      const isFascia = variants.find(variant => variant.id === fascia);
      const isLightGuards = variants.find(
        variant => variant.id === lightGuards,
      );

      const addonId =
        isFascia !== undefined
          ? fascia
          : isLightGuards !== undefined
          ? lightGuards
          : id;

      return {
        quantity: isMeasureInsurance || isWifiHub || isFascia ? 1 : quantity,
        id: addonId,
        properties: !isMeasureInsurance
          ? {
              _upi: upi,
              'Product for': `${parentProductTitle} - Room: ${roomName}`,
            }
          : {
              _upi: '',
              'Product for': `${parentProductTitle} - Room: ${roomName}`,
            },
      };
    });
};
